import { render, staticRenderFns } from "./TheLayoutNavigationList.vue?vue&type=template&id=677cf7c6&scoped=true"
import script from "./TheLayoutNavigationList.vue?vue&type=script&lang=js"
export * from "./TheLayoutNavigationList.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutNavigationList.vue?vue&type=style&index=0&id=677cf7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677cf7c6",
  null
  
)

export default component.exports